export default function CheckboxIcon({ className }: { className: string }) {
	return (
		<svg className={className} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10 3L4.5 8.5L2 6"
				strokeWidth="1.6666"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<defs>
				<linearGradient
					id="check"
					x1="2"
					y1="3"
					x2="9.01376"
					y2="10.5024"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset="0.24238" stopColor="#FFF" />
					<stop offset="1" stopColor="#F2F7FA" />
				</linearGradient>
			</defs>
		</svg>
	)
}
